var intersectionD = require('./../distances/intersection');

module.exports = function intersection(a, b) {
    return 1 - intersectionD(a,b);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-distance/src/similarities/intersection.js
 ** module id = 78
 ** module chunks = 0
 **/